import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'promotions'
})
export class PromotionsPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
